import { getSHA256Hash } from '../../../utils/sha256';

const formatId = string => {
  if (!string) return '';
  return string
    .toLowerCase()
    .split(' ')
    .join('-');
};

const formatPrice = num => Math.round((num + Number.EPSILON) * 100) / 100;

const formatItem = (item, index, list) => {
  let obj = {
    item_id: item.id,
    item_name: item.name,
    currency: 'EUR',
    price: formatPrice(item.price), // TODO: google lo legge in milioni, capire se ok
    quantity: item.quantity || 1,
    item_brand: item.brand,
    item_category: item.type,
    item_category2: item.categoryName,
    item_category3: item.subcategoryName,

    discount: formatPrice((item.listPrice || item.price) - item.price), // TODO: non appare in analytics

    // location_id: "L_12345", // TODO: cosa sarebbe ?
    // affiliation: "Google Merchandise Store", // TODO: cosa sarebbe ?
  };

  if (list) {
    obj = {
      ...obj,
      index,
      item_list_id: formatId(list.id),
      item_list_name: list.name,
    };
  }

  return obj;
};

const addAdvancedData = async (obj, order) => {
  if (!!order.userEmail) {
    obj.sha256_email_address = await getSHA256Hash(order.userEmail);
  }
  if (!!order.billing) {
    if (!!order.billing.phone) {
      obj.sha256_phone_number = await getSHA256Hash(order.billing.phone);
    }
    if (!!order.billing.firstname) {
      obj.address = {
        ...obj.address,
        sha256_first_name: await getSHA256Hash(order.billing.firstname),
      };
    }
    if (!!order.billing.lastname) {
      obj.address = {
        ...obj.address,
        sha256_last_name: await getSHA256Hash(order.billing.lastname),
      };
    }
    if (!!order.billing.address1) {
      obj.address = {
        ...obj.address,
        street: order.billing.address1,
      };
    }
    if (!!order.billing.city) {
      obj.address = {
        ...obj.address,
        city: order.billing.city,
      };
    }
    if (!!order.billing.province) {
      obj.address = {
        ...obj.address,
        region: order.billing.province,
      };
    }
    if (!!order.billing.zipcode) {
      obj.address = {
        ...obj.address,
        postal_code: order.billing.zipcode,
      };
    }
    if (!!order.billing.country) {
      obj.address = {
        ...obj.address,
        country: order.billing.country,
      };
    }
  }
  return obj;
};

export function gtmToGa4ViewItemList(products = [], listInfo) {
  try {
    if (!!window.gtag && !!listInfo) {
      window.gtag('event', 'view_item_list', {
        item_list_id: formatId(listInfo.id),
        item_list_name: listInfo.name,
        items: products.map((product, index) =>
          formatItem(product, index, listInfo)
        ),
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4SelectItem(product, listInfo) {
  try {
    if (!!window.gtag && !!product && !!listInfo) {
      window.gtag('event', 'select_item', {
        item_list_id: formatId(listInfo.id),
        item_list_name: listInfo.name,
        items: [formatItem(product, 0, listInfo)],
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4ViewItem(product) {
  try {
    if (!!window.gtag && !!product) {
      window.gtag('event', 'view_item', {
        currency: 'EUR',
        value: product.price,
        items: [formatItem(product, 0)],
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4AddToCart(product, listInfo) {
  try {
    if (!!window.gtag && !!product) {
      window.gtag('event', 'add_to_cart', {
        currency: 'EUR',
        value: product.price, // FIXME: capire se riguarda il prodotto o il carrello
        items: [formatItem(product, 0, listInfo)],
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4RemoveFromCart(product) {
  try {
    if (!!window.gtag && !!product) {
      window.gtag('event', 'remove_from_cart', {
        currency: 'EUR',
        value: product.price, // FIXME: capire se riguarda il prodotto o il carrello
        items: [formatItem(product, 0)],
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4ViewCart(products = [], value = 0) {
  try {
    if (!!window.gtag) {
      window.gtag('event', 'view_cart', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4BeginCheckout(products = [], value = 0) {
  try {
    if (window.gtag) {
      window.gtag('event', 'begin_checkout', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),

        // coupon: "SUMMER_FUN", // TODO: gestire coupon
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4AddShippingInfo(
  products = [],
  value = 0,
  shippingInfo
) {
  try {
    if (!!window.gtag && !!shippingInfo) {
      window.gtag('event', 'add_shipping_info', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
        shipping_type: shippingInfo.type,
        shipping_cost: shippingInfo.cost,
        shipping_with_pudo: shippingInfo.withPudo,

        // coupon: "SUMMER_FUN", // TODO: gestire coupon
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4AddPaymentInfo(products = [], value = 0, paymentInfo) {
  try {
    if (!!window.gtag && !!paymentInfo) {
      window.gtag('event', 'add_payment_info', {
        currency: 'EUR',
        value,
        items: products.map((product, index) => formatItem(product, index)),
        payment_type: paymentInfo.type,
        payment_cost: paymentInfo.cost,

        // coupon: "SUMMER_FUN", // TODO: gestire coupon
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export function gtmToGa4Search(search_term = '') {
  try {
    if (!!window.gtag) {
      window.gtag('event', 'search', {
        search_term,
      });
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}

export async function gtmToGa4Purchase(order, store) {
  try {
    if (!!window.gtag && !!order) {
      // 1 sconto sui prodotti
      const discountProducts = order.items.reduce((acc, curr) => {
        return acc + (curr.listPrice - curr.price) * curr.quantity;
      }, 0);

      // 2 sconto sulle spedizioni
      const shippingCategory = order.items.reduce((acc, curr) => {
        return acc > curr.shippingCategory ? acc : curr.shippingCategory;
      }, 0);

      const discountShippings =
        order.shipping.typeName === 'Corriere Espresso' &&
        order.grandTotal > store.costiSpedizione.freeShippingThreshold
          ? store.glsShipping[`priceCategory${shippingCategory}`]
          : 0;

      // 3 coupon
      const totalProducts = order.items.reduce((acc, curr) => {
        return acc + curr.price * curr.quantity;
      }, 0);
      let discountCoupon = 0;
      if (!!order.coupon) {
        if (!!order.coupon.discountFixed) {
          discountCoupon = order.coupon.discountFixed;
        } else {
          discountCoupon =
            (totalProducts * (order.coupon.discountPercent || 0)) / 100;
        }
      }

      const totalDiscounts = formatPrice(
        discountProducts + discountShippings + discountCoupon
      );

      let obj = {
        transaction_id: order.id,
        value: order.revenue,
        currency: 'EUR',

        shipping: order.shipping,
        tax: order.tax,
        coupon: order.coupon,

        // for gads
        discount: totalDiscounts,

        items: order.items.map((product, index) => formatItem(product, index)),
      };

      obj = await addAdvancedData(obj, order);

      window.gtag('event', 'purchase', obj);
    }
  } catch (err) {
    console.error('GTAG Error', err);
  }
}
